export class AssignShippingDto {

    refNo: number;
    transactionName: string;
    transactionNo: string;
    deliveryDate: string;
    deliverySlot: string;
    status: string;
    serviceManCode: string;
    isApproved: boolean;
    noOfPacket: number;
    fromLocationCode: number;
    reasonCode: number;
    notes: string;
    otp: String;
}
